import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

export type LayerOrganizeSortableRowProps = {
  id: string
  className?: string
  children: React.ReactNode
}

/** One dnd-sortable row; the whole row is the drag handle. */
function LayerOrganizeSortableRow(props: LayerOrganizeSortableRowProps) {
  const { id, className, children } = props
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id })

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 10 : undefined,
      }}
      className={cn(
        "relative flex cursor-grab items-center gap-2 rounded-md border bg-background px-2 py-1.5 text-xs",
        isDragging && "opacity-70 shadow-md",
        className,
      )}
      {...attributes}
      {...listeners}
    >
      <Icon
        src="grip-vertical"
        size={10}
        className="shrink-0 text-muted-foreground/70"
      />
      {children}
    </div>
  )
}

export default LayerOrganizeSortableRow
